import React from 'react'
import PropTypes from 'prop-types'

import './styles.scss'

export const bc = 'reports-block'

export const renderResponses = responses =>
  responses.map((response, i) => (
    <span key={i} className={`${bc}__response`}>
      {response}
    </span>
  ))

const Block = ({ reviewerType, responses, color }) => {
  return (
    <div className={bc} style={{ backgroundColor: color }}>
      <span className={`${bc}__type`}>{reviewerType}</span>
      {responses instanceof Array ? renderResponses(responses) : <span className={`${bc}__response`}>{responses}</span>}
    </div>
  )
}

Block.propTypes = {
  responses: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  reviewerType: PropTypes.oneOf(['Self', 'Direct', 'Peers', 'Supervisors']).isRequired,
  color: PropTypes.string.isRequired,
}

export default Block
